// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__18xyf","validationTips":"StatementDescriptor_validationTips__16w9t"};